import { onCopilotChatDrawerClosed, removeTasksHubWindowMutator, } from "owa-copilot-chat-drawer-store";
import { orchestrator } from "satcheljs";
import { logTasksHubClosed } from "../utils/logTasksHubClosed";

orchestrator(onCopilotChatDrawerClosed, ({ windowKey, mailboxInfo }) => {
    if (mailboxInfo) {
        logTasksHubClosed(windowKey, mailboxInfo, "drawerClosed");
    }
    
    removeTasksHubWindowMutator(windowKey);
});
